import { useEffect, useRef, useState } from "react";

const DropdownWithCheckboxes = ({
  label,
  options,
  values,
  onChange,
  name,
  labelClassName,
  touched,
  errors,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
   const [openUpwards, setOpenUpwards] = useState(false);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleDropdown = () => {
    if (buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      setOpenUpwards(spaceBelow < 250); // threshold
    }
    setIsOpen((prev) => !prev);
  };

  const handleCheckboxChange = (value) => {
    const newValues = values.includes(value)
      ? values.filter((val) => val !== value)
      : [...values, value];
    onChange(name, newValues);
  };

  return (
    <div className="flex flex-col" ref={dropdownRef}>
      <label className={`p-1 text-gray-700 flex gap-1 ${labelClassName || 'text-lg'}`}>
        {label}
        {touched && errors ? (
        <div className="text-red-500 text-[12px]">*</div>
      ) : null}
      </label>
      <div className="relative">
        <button
          type="button"
          onClick={toggleDropdown}
          ref={buttonRef}
          className="p-2 rounded-lg border border-gray-300 text-gray-700 outline-none w-full text-left flex justify-between items-center"
        >
          <span>
            {values.length > 0
              ? `${values.length} selected`
              : "Select languages"}
          </span>
          <svg
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M19 9l-7 7-7-7"
            />
          </svg>
        </button>

        {isOpen && (
          <div className={`
      absolute z-50 w-full bg-white rounded-xl border border-gray-200
      shadow-xl max-h-24 overflow-y-auto
      transition-all duration-200 ease-out
      ${openUpwards ? "bottom-full mb-2" : "top-full mt-2"}
    `}>
            {options?.map((option, index) => (
              <div
                key={index}
                className="p-2 hover:bg-gray-100 flex items-center"
              >
                <input
                  type="checkbox"
                  id={`option-${option?.languageId}`}
                  checked={values.includes(option?.languageId)}
                  onChange={() =>
                    handleCheckboxChange(option?.languageId)
                  }
                  className="mr-2"
                />
                <label
                  htmlFor={`option-${option?.languageId}`}
                  className="w-full cursor-pointer"
                >
                  {option?.name}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>
      {touched && errors ? <div className="text-red-500 text-[12px]">{errors}</div> : null}
    </div>
  );
};

export default DropdownWithCheckboxes;
